var _defs, _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg00025IconServiceServiceProviders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fb45399d-101d-4307-af8b-b95e6d550e3d",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "efc8edab-197e-437c-8de3-c7ad62d8cf10",
    x1: 6.49,
    y1: 6.29,
    x2: 6.49,
    y2: 18.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#54aef0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1988d9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f6def0c6-d993-4d63-90a2-b68ba69df74a",
    x1: 7.13,
    y1: -0.19,
    x2: 8.01,
    y2: 10.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#54aef0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1988d9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ada114d9-8e8c-4a06-9507-f18462256263",
    x1: 13.76,
    y1: 18.05,
    x2: 13.76,
    y2: 10.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#76bc2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#81ce31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#86d633"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-manage-325") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.35,10.31a.51.51,0,0,1,.51-.51h2.93A6.53,6.53,0,0,0,7.48,7.37C3,7.37.65,10.18.2,14.77a1.29,1.29,0,0,0,1.16,1.42h8Z",
    fill: "url(#efc8edab-197e-437c-8de3-c7ad62d8cf10)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48,8.34a4.09,4.09,0,0,1-2.21-.65L7.46,13.4,9.63,7.72A4,4,0,0,1,7.48,8.34Z",
    fill: "#fff",
    opacity: 0.8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.48,
    cy: 4.25,
    r: 4.08,
    fill: "url(#f6def0c6-d993-4d63-90a2-b68ba69df74a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.59,15.71h2.34v2.34H12.59ZM9.86,12.59H12.2V10.25h-2a.33.33,0,0,0-.33.33Zm.33,5.46h2V15.71H9.86v2A.33.33,0,0,0,10.19,18.05Zm-.33-2.73H12.2V13H9.86Zm5.45,2.73h2a.32.32,0,0,0,.32-.33v-2H15.31Zm-2.72-2.73h2.34V13H12.59Zm2.72,0h2.34V13H15.31Zm0-5.07v2.34h2.34v-2a.32.32,0,0,0-.32-.33Zm-2.72,2.34h2.34V10.25H12.59Z",
    fill: "url(#ada114d9-8e8c-4a06-9507-f18462256263)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg00025IconServiceServiceProviders);
export default __webpack_public_path__ + "static/media/00025-icon-service-Service-Providers.e7905739f915145ff598dc42c8994ab6.svg";
export { ForwardRef as ReactComponent };